import React from 'react';
import { Link } from 'react-router';
import { getTextImagesFromType } from '../../utils';
import {CREDENTIAL_TYPE_LABELS} from '../../constants';

const CredentialSummaryCard = ({type, incomplete, total}) => {
  const [textImage, textImage2x] = getTextImagesFromType(type);

  return (
    <div>
      {CREDENTIAL_TYPE_LABELS[type] && (
        <Link to={`/credentials/${type}-passes`} className="panel-link">
          <div className="panel panel-card panel-card-sm">
            <div className={`card-brand card-${CREDENTIAL_TYPE_LABELS[type]["type_label"]}`}>
              <img src={textImage} srcSet={`${textImage} 1x, ${textImage2x} 2x`} alt={`${CREDENTIAL_TYPE_LABELS[type]["plural"]} text`} />
            </div>
            <div className="panel-body">
              <h4>{CREDENTIAL_TYPE_LABELS[type]["plural"]}</h4>
              <span>{incomplete}/{total} Remaining</span>
              <div className="icon-gray_arrow_forward panel-cta"></div>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default CredentialSummaryCard;



// WEBPACK FOOTER //
// ./src/components/Credentials/CredentialSummaryCard.js